import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { LocationContextPanelModule } from '../location-context-panel/location-context-panel.module';
import { MaterialModule } from '../material/material.module';
import { NotificationsModule } from '../notifications/notifications.module';
import { Pages } from '../pages.config';
import { StatisticsComponent } from './statistics/statistics.component';
import { StatisticsEffects } from './store/statistics.effects';
import * as fromStatistics from './store/statistics.reducers';

// NOTE: not used
// Planned at some point in the past but abonded for now

const statisticsRoutes: Routes = [
    { path: Pages.statistics.path, component: StatisticsComponent },
    { path: '**', component: StatisticsComponent }
];

@NgModule({
    declarations: [StatisticsComponent],
    imports: [
        CommonModule,
        MaterialModule,
        LocationContextPanelModule,
        NotificationsModule,
        RouterModule.forChild(statisticsRoutes),
        StoreModule.forFeature(fromStatistics.statisticsFeatureKey, fromStatistics.statisticsContextReducer, {
            metaReducers: fromStatistics.metaReducers
        }),
        EffectsModule.forFeature([StatisticsEffects])
    ]
})
export class StatisticsModule {}
